module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Renee-meisje-goudfolie-emboss-preeg-crush-papier-corn-drukwerk-2.47813117.jpg";